export interface PhoneProps {
    phone: string | undefined | null;
}

export const formatPhone = (value: string | null | undefined) => {
    const phone = value?.replace(/\D/g, '')?.slice(0, 10);
    if (!phone || phone.length !== 10) {
        return;
    }

    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export function Phone({ phone }: PhoneProps) {
    const formattedPhone = formatPhone(phone);

    return formattedPhone;
}
